import React from 'react';
import './home.css'

function Home() {
  return (
    <div className="home">
      <h1>ZANF BAZAR E PAPELARIA</h1>
      <h2>Nosso site está em desenvoldimento...</h2>

      <div className='container-dados'>
        <h3>Avenida 1, 77 - Centro - Santa Gertrudes/SP</h3>
        <h3>Telefone: +55 19 3545-4770</h3>
        <h3>vendas@zanfpapelaria.com.br</h3>
      </div>
    </div>
  );
}

export default Home;